import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: [ './home.component.scss' ]
})
export class HomeComponent implements OnInit {
  
// 30_01_2025

  constructor (
    private _route: ActivatedRoute,
  ) {
    const key = this._route.snapshot.paramMap.get('key');
    //console.log("key: " + key)
  }


  ngOnInit (): void {

  }

}
